import { required, maxLength, numeric } from 'vuelidate/lib/validators'

const regexUsuario = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[a-zA-Z0-9\s]+$/g.test(value)
}

export const validateData = {
  form: {
    numero: { required, maxLength: maxLength(10), numeric },
    usuario: { required, regexUsuario, maxLength: maxLength(30) },
    tronco: { required },
  },
}

export const validateComputed = {
  numeroErrors() {
    const errors = []
    if (!this.$v.form.numero.$dirty) return errors
    !this.$v.form.numero.maxLength && errors.push('Número não pode ter mais de 10 dígitos')
    !this.$v.form.numero.required && errors.push('Número é obrigatório.')
    !this.$v.form.numero.numeric && errors.push('Apenas caracteres numéricos são válidos.')
    return errors
  },
  usuarioErrors() {
    const errors = []
    if (!this.$v.form.usuario.$dirty) return errors
    !this.$v.form.usuario.maxLength && errors.push('Nome não pode ter mais de 30 dígitos')
    !this.$v.form.usuario.required && errors.push('Nome é obrigatório.')
    !this.$v.form.usuario.regexUsuario && errors.push('Apenas letras, números e espaço são válidos.')
    return errors
  },
  troncoErrors() {
    const errors = []
    if (!this.$v.form.tronco.$dirty) return errors
    !this.$v.form.tronco.required && errors.push('Tronco é obrigatório.')
    return errors
  },
}
